// src/utils/logAudit.js
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase/firebase";
import { getAuth } from "firebase/auth";

export const logAuditEvent = async ({
  actionType,
  entityType,
  entityId = "",
  description,
  companyId = null,
  email = null
}) => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    // Check if user is authenticated
    if (!user && !email) {
      console.warn('Cannot log audit: no authenticated user or email provided');
      return;
    }

    const auditData = {
      userEmail: email || user?.email || "System",
      userId: user?.uid || null,
      actionType: String(actionType),
      entityType: String(entityType),
      entityId: String(entityId),
      description: String(description),
      timestamp: serverTimestamp(),
      companyId: companyId || null,
      // Add fallback timestamp
      createdAt: new Date().toISOString()
    };

    console.log('Attempting to log audit with data:', auditData);

    const docRef = await addDoc(collection(db, "auditLogs"), auditData);
    console.log('Audit logged successfully with ID:', docRef.id);

  } catch (error) {
    console.error("Error logging audit event:", error);
    console.error("Error code:", error.code);
    console.error("Error message:", error.message);
    
    // Don't throw the error - audit logging should not break main flow
  }
};

export const logError = async (error) => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;
    
    await addDoc(collection(db, "errorLogs"), {
      message: String(error.message || 'Unknown error'),
      stack: String(error.stack || ''),
      timestamp: serverTimestamp(),
      userEmail: user?.email || "System",
      userId: user?.uid || null
    });
  } catch (logError) {
    console.error("Error logging error:", logError);
  }
};
